export default {
  h1: 'yellow',
  link: '#269c74',
};
